(() => {
  if (!window.__dx) return;
  const { root, cfg, RM, $, $$, esc, tee, T } = window.__dx;
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage unavailable */ } },
  };
  const toastEl = $('[data-toast]');
  let toastTimer;
  const note = (msg) => {
    if (!toastEl) return;
    toastEl.innerHTML = `<p>${esc(T(msg))}</p>`;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  };
  const go = (sel) => { const el = $(sel); if (el) el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); };

  // ---------- Background zero rotates with scroll ----------
  const bg = $('[data-bg0]');
  if (bg && !RM) {
    let ticking = false;
    addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { bg.style.setProperty('--r', `${scrollY * 0.06}deg`); ticking = false; });
    }, { passive: true });
  }

  // ---------- Like / save / share / comment ----------
  const likeBtn = $('[data-like]');
  const saveBtn = $('[data-save]');
  const heart = $('.dy-heart');
  const setPressed = (btn, on, key) => { if (!btn) return; btn.setAttribute('aria-pressed', String(on)); store.set(key, on ? '1' : '0'); };
  if (likeBtn) {
    setPressed(likeBtn, store.get('dy-like') === '1', 'dy-like');
    likeBtn.addEventListener('click', () => setPressed(likeBtn, likeBtn.getAttribute('aria-pressed') !== 'true', 'dy-like'));
  }
  if (saveBtn) {
    setPressed(saveBtn, store.get('dy-save') === '1', 'dy-save');
    saveBtn.addEventListener('click', () => {
      const on = saveBtn.getAttribute('aria-pressed') !== 'true';
      setPressed(saveBtn, on, 'dy-save');
      note(on ? 'Saved on this device' : 'Removed from saved');
    });
  }
  const pop = () => {
    if (!heart) return;
    heart.classList.remove('is-pop'); void heart.offsetWidth; heart.classList.add('is-pop');
    setPressed(likeBtn, true, 'dy-like');
  };
  const media = $('.dy-media');
  if (media) {
    media.addEventListener('dblclick', pop);
    let lastTap = 0;
    media.addEventListener('touchend', () => {
      const now = Date.now();
      if (now - lastTap < 300) pop();
      lastTap = now;
    }, { passive: true });
  }
  const shareBtn = $('[data-share]');
  if (shareBtn) {
    shareBtn.addEventListener('click', async () => {
      const data = { title: cfg.title, url: location.href.split('#')[0] };
      try {
        if (navigator.share) { await navigator.share(data); return; }
        await navigator.clipboard.writeText(data.url);
        note('Link copied');
      } catch (e) { /* share cancelled */ }
    });
  }
  $$('[data-goto]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); go(b.dataset.goto); }));

  // ---------- Tabs follow the section in view ----------
  const tabs = $$('.dy-tabs a');
  if (tabs.length) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      tabs.forEach((t) => t.classList.toggle('is-on', t.getAttribute('href') === `#${en.target.id}`));
    }), { rootMargin: '-40% 0px -55% 0px' });
    tabs.forEach((t) => { const s = $(t.getAttribute('href')); if (s) io.observe(s); });
  }

  // ---------- Stories ----------
  const stories = [
    { id: 'drop', label: 'Drop 001', cta: true, slides: [
      { bg: '#0a0a0a', big: 'Lead.\nNever\nfollow.', small: 'Drop 001 is out now.' },
      { bg: '#ffffff', fg: '#0a0a0a', img: 'product', big: 'White body.\nPick your sleeves.', small: 'Black, blue or red. Sizes S to XXL.' },
      { bg: '#ff2d2d', big: 'Free\nworldwide\nshipping.', small: 'Tracked all the way to your door.' }] },
    { id: 'fit', label: 'Fit', cta: true, slides: [
      { bg: '#ffffff', fg: '#0a0a0a', img: 'tee', big: 'Unisex\nregular fit.', small: `${T('Chest width')}: ${(cfg.sizes || []).map((z) => `${z.s} ${z.chest} cm`).join(', ')}.` },
      { bg: '#d7ff3a', fg: '#0a0a0a', big: 'Want it\noversized?', small: 'Size up one. Not sure? Try the fit finder on this page.' }] },
    { id: 'ship', label: 'Shipping', cta: true, slides: [
      { bg: '#0a0a0a', big: 'Free\nshipping.\nEverywhere.', small: 'Every order ships with tracking.' },
      { bg: '#ffffff', fg: '#0a0a0a', big: '7-15 days\nin the EU.', small: 'About 9-23 business days elsewhere. Your exact estimate is on this page.' }] },
    { id: 'returns', label: 'Returns', cta: true, slides: [
      { bg: '#ff2d2d', big: '14 days\nto change\nyour mind.', small: 'Return an unworn item within 14 days of delivery.' }] },
    { id: 'care', label: 'Care', slides: [
      { bg: '#ffffff', fg: '#0a0a0a', big: '30\u00b0C.\nInside out.', small: `${T(cfg.fabric || '')} ${T('No tumble dryer. Do not iron the print.')}`.trim() }] },
  ];
  const viewer = $('[data-story]');
  if (!viewer || !stories.length) return;
  const DUR = 5000;
  let si = 0, sl = 0, start = 0, paused = 0, pauseAt = 0, raf = 0, lastFocus = null;

  const slideHTML = (s) => {
    let visual = '';
    if (s.img === 'product') visual = cfg.image ? `<div class="dy-simg"><img src="${esc(cfg.image)}" alt=""></div>` : `<div class="dy-simg">${tee('front')}</div>`;
    if (s.img === 'tee') visual = `<div class="dy-simg">${tee('front')}</div>`;
    const big = esc(T(s.big || '')).replace(/\n/g, '<br>');
    return `<div class="dy-slide" style="background:${esc(s.bg || '#0a0a0a')};color:${esc(s.fg || '#fff')}">${visual}<p class="dy-big">${big}</p>${s.small ? `<p class="dy-small">${esc(T(s.small))}</p>` : ''}</div>`;
  };

  const render = () => {
    const st = stories[si];
    const s = st.slides[sl];
    const fg = s.fg || '#fff';
    const darkText = !/^#f/i.test(fg);
    viewer.innerHTML = `<div class="dy-frame" role="dialog" aria-modal="true" aria-label="${esc(st.label)}" style="color:${esc(fg)}">
      <div class="dy-bars">${st.slides.map((_, k) => `<i><b style="width:${k < sl ? 100 : 0}%"></b></i>`).join('')}</div>
      <div class="dy-shead"><span class="dy-mini">0</span>0following <span style="opacity:.6;font-weight:400">${esc(T(st.label))}</span>
        <button type="button" class="dy-x" aria-label="Close">&times;</button></div>
      ${slideHTML(s)}
      <div class="dy-tap"><button type="button" aria-label="Previous"></button><button type="button" aria-label="Next"></button></div>
      ${st.cta ? `<div class="dy-scta"><button type="button" class="dx-btn ${darkText ? 'dx-btn--dark' : 'dx-btn--light'}" data-scta>${T('Shop the drop')}</button></div>` : ''}
    </div>`;
    const [prevB, nextB] = $$('.dy-tap button', viewer);
    prevB.addEventListener('click', prev);
    nextB.addEventListener('click', next);
    $('.dy-x', viewer).addEventListener('click', close);
    const cta = $('[data-scta]', viewer);
    if (cta) cta.addEventListener('click', () => { close(); go('#dy-post'); });
    const frame = $('.dy-frame', viewer);
    frame.addEventListener('pointerdown', () => { pauseAt = performance.now(); });
    frame.addEventListener('pointerup', () => { if (pauseAt) { paused += performance.now() - pauseAt; pauseAt = 0; } });
    start = performance.now(); paused = 0; pauseAt = 0;
    $('.dy-x', viewer).focus();
  };

  const tick = (now) => {
    if (!viewer.classList.contains('is-on')) return;
    const bar = $$('.dy-bars b', viewer)[sl];
    const held = pauseAt ? now - pauseAt : 0;
    const p = Math.min(1, (now - start - paused - held) / DUR);
    if (bar) bar.style.width = `${p * 100}%`;
    if (p >= 1 && !RM) { next(); }
    raf = requestAnimationFrame(tick);
  };

  function next() {
    const st = stories[si];
    if (sl < st.slides.length - 1) { sl += 1; render(); return; }
    if (si < stories.length - 1) { si += 1; sl = 0; render(); return; }
    close();
  }
  function prev() {
    if (sl > 0) { sl -= 1; render(); return; }
    if (si > 0) { si -= 1; sl = stories[si].slides.length - 1; render(); return; }
    render();
  }
  function open(id) {
    const i = stories.findIndex((s) => s.id === id);
    si = i < 0 ? 0 : i; sl = 0;
    lastFocus = document.activeElement;
    viewer.classList.add('is-on');
    document.documentElement.style.overflow = 'hidden';
    render();
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(tick);
    store.set(`dy-seen-${stories[si].id}`, '1');
    const hb = $(`[data-open-story="${stories[si].id}"]`);
    if (hb) hb.classList.remove('is-new');
  }
  function close() {
    viewer.classList.remove('is-on');
    viewer.innerHTML = '';
    document.documentElement.style.overflow = '';
    cancelAnimationFrame(raf);
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-open-story]').forEach((b) => {
    if (store.get(`dy-seen-${b.dataset.openStory}`) === '1') b.classList.remove('is-new');
    b.addEventListener('click', () => open(b.dataset.openStory));
  });
  viewer.addEventListener('click', (e) => { if (e.target === viewer) close(); });
  addEventListener('keydown', (e) => {
    if (!viewer.classList.contains('is-on')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
  });
})();
